import { CustomCurrencySymbolsInterface } from './interfaces/custom-currency-symbols.interface';
import { NgModule, ModuleWithProviders, InjectionToken } from '@angular/core';

export interface TechLibPipeConfig {
  language: string;
  groupSeparator: string;
  decimalSeparator: string;
  numberOfDecimals: string;
  // baseCurrenncy: string;
  shortDatePattern: string;
  formatsTech: string;
  // symbolPosition: string;
  customCurrencySymbols: CustomCurrencySymbolsInterface[];
  customCurrencyPosition: string;
}

export const TECH_LIB_PIPE_CONFIG = new InjectionToken<TechLibPipeConfig>(
  'TechLibPipe Config'
);

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
})
export class TechLibPipeModule {
  static initializeApp(
    config: TechLibPipeConfig
  ): ModuleWithProviders<TechLibPipeModule> {
    return {
      ngModule: TechLibPipeModule,
      providers: [{ provide: TECH_LIB_PIPE_CONFIG, useValue: config }],
    };
  }
}
